export const productionServiceTypeServer = 0; // 环境类型 0：测试开发环境 1：生产环境
export const TextServer = ''; // 测试环境地址
export const productionServer = ''; // 生产环境地址
